import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import { BaseContainer, BaseTitle } from './styles';
import { SectionName } from '../common/styles';

const Container = styled(BaseContainer)`
  margin-top: ${props => (props.theme.isMobile ? '32px' : '80px')};
  margin-bottom: ${props => (props.theme.isMobile ? '32px' : '80px')};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Intro = styled.div`
  position: relative;
  text-align: ${props => (props.theme.isMobile ? 'left' : 'center')};
`;

const IntroTitle = styled(SectionName)`
  color: ${props => props.theme.bodyColor};
  font-size: 16px;
`;

const IconContainer = styled(BaseContainer)`
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    width: 76vw;
    max-width: 1088px;
  `)};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;

const Image = styled(Img)`
  width: 120px;
  box-shadow: 0 3px 20px ${props => props.theme.secondaryColorLight};
  margin: 0 10px;
`;

const Title = styled(BaseTitle)`
  max-width: 980px;
`;

const Desc = styled.p`
  font-size: 18px;
  text-align: left;
  max-width: 980px;
`;

export default function FundManagement() {
  const { partnerImages } = React.useContext(ThemeContext);

  return (
    <Container>
      <Intro>
        <IntroTitle>Who we&apos;re working with</IntroTitle>
        <Title>
          Trusted by Leading Global & Domestic Brands
        </Title>
        <Desc>
          We work with over 100 of the world’s leading financial services brands,
          creating compelling campaigns that are relevant to a confident investor
          and adviser audience.
        </Desc>
      </Intro>
      <IconContainer>
        {partnerImages.map(image => <Image key={image} src={image} />)}
      </IconContainer>
    </Container>
  );
}
